import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Reveal from "@/components/base/Reveal";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  return (
    <>
      <Seo
        title="常见问题 | 511爆料匿名投稿与隐私保护说明"
        description="关于511爆料匿名投稿是否真的匿名、投稿多久有回应、如何理解状态标签、能否申请撤回稿件等常见问题，本文集中解答，帮助投稿人安心投喂瓜料。"
        canonical="https://cqkczx.cn/faq"
        keywords="511爆料常见问题,匿名投稿是否安全,511爆料审核时长,爆料撤回"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((item) => ({
              "@type": "Question",
              name: item.q,
              acceptedAnswer: { "@type": "Answer", text: item.a },
            })),
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "首页",
                item: "https://cqkczx.cn/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "常见问题",
                item: "https://cqkczx.cn/faq",
              },
            ],
          },
        ]}
      />

      <section className="w-full bg-background-100/70 border-b border-background-200/70">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8 pt-6 pb-10 md:pb-12">
          <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "常见问题" }]} />
          <h1 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h1>
          <p className="mt-3 max-w-3xl text-sm md:text-base text-foreground-600 leading-relaxed">
            投稿人最关心的，永远是安全与回应。下面这些问题的答案，也是我们日常处理线索时反复确认的准则。
          </p>
        </div>
      </section>

      <section className="w-full max-w-5xl mx-auto px-4 md:px-8 py-10 md:py-14">
        <Reveal>
          <FaqAccordion items={faqs} defaultOpen={0} />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-10 p-6 md:p-8 rounded-lg bg-secondary-50 border border-secondary-200/80">
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
              还有疑问没解决？
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              如果你对投稿流程、隐私处理或内容处置仍有疑问，欢迎直接联系我们，或先看看我们处理线索的完整流程。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/submit"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                <i className="ri-send-plane-fill"></i>
                我要爆料
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors"
              >
                <i className="ri-information-line"></i>
                了解 511爆料
              </Link>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}